import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Search as SearchIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import GlobalSearch from '../GlobalSearch';

const GlobalSearchModal = ({ menuJson = [], onNavigate }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNavigate = (option) => {
    handleClose();
    if (onNavigate) {
      onNavigate(option);
    }
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleOpen}
        sx={{ 
          ml: 1,
          display: { xs: 'flex', sm: 'none' } // Só aparece em mobile
        }}
      >
        <SearchIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={isMobile}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 2,
            margin: isMobile ? 0 : 2,
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            bgcolor: '#782cdf',
            color: 'white',
            py: 2,
          }}
        >
          <Typography variant="h6" component="div">
            Buscar no Menu
          </Typography>
          <IconButton
            color="inherit"
            onClick={handleClose}
            edge="end"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3, bgcolor: '#fafafa', minHeight: 200 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              Digite para encontrar páginas e funcionalidades do sistema
            </Typography>
            
            <Box
              sx={{
                '& .MuiAutocomplete-root': {
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                    color: '#333',
                    '& input': {
                      color: '#333',
                      '&::placeholder': {
                        color: '#999',
                        opacity: 1,
                      },
                    },
                    '& fieldset': {
                      borderColor: '#ddd',
                    },
                    '&:hover fieldset': {
                      borderColor: '#782cdf',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#782cdf',
                    },
                  },
                },
              }}
            >
              <GlobalSearch
                menuJson={menuJson}
                onNavigate={handleNavigate}
              />
            </Box>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography variant="caption" color="textSecondary">
              💡 Dica: Use palavras-chave como "usuário", "relatório", "cadastro" para encontrar rapidamente o que procura
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GlobalSearchModal;